export const LogoLight = () => (
  <svg
    height={40}
    viewBox="0 0 51 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.1421 36.9472C21.1054 36.9472 19.1859 36.159 17.7441 34.7259L13.4635 30.4713L18.1992 25.7645L22.4842 30.019C22.7095 30.2429 22.9663 30.2922 23.1421 30.2922C23.3178 30.2922 23.5746 30.2429 23.7999 30.019L33.6182 20.2605L38.3538 24.9673L28.5356 34.7259C27.0937 36.159 25.1787 36.9472 23.1376 36.9472H23.1421Z"
      fill="#7041FF"
    />
    <path
      d="M40.9492 48H10.1652C4.55992 48 0 43.4678 0 37.8966V25.4062C0 22.7057 1.05888 20.1709 2.97837 18.2631L18.3704 2.96025C20.2899 1.05244 22.8447 0 25.5572 0C28.2697 0 30.8245 1.05244 32.744 2.96025L48.136 18.2586C50.0555 20.1664 51.1144 22.7057 51.1144 25.4018V37.8921C51.1144 43.4633 46.5545 47.9955 40.9492 47.9955V48ZM25.5572 6.65945C24.629 6.65945 23.7594 7.01773 23.106 7.6671L7.71402 22.9655C7.06067 23.6149 6.7002 24.4792 6.7002 25.4018V37.8921C6.7002 39.791 8.25472 41.3361 10.1652 41.3361H40.9492C42.8597 41.3361 44.4142 39.791 44.4142 37.8921V25.4018C44.4142 24.4792 44.0537 23.6149 43.4004 22.9655L28.0084 7.6671C27.355 7.01773 26.4809 6.65945 25.5572 6.65945Z"
      fill="#05CDFF"
    />
  </svg>
);
